import { components } from "react-select";

const MultiValue = (props: any) => {
  return <components.MultiValue cropWithEllipsis={false} {...props} />;
};

export default MultiValue;
